import {
	TEMPLATE_REQUEST,
	TEMPLATE_CREATE,
	TEMPLATE_GET_LIST,
	TEMPLATE_GET,
	TEMPLATE_SUCCESS,
	TEMPLATE_ERROR,
	TEMPLATE_SET_CURRENT
} from '../types';

import axios from '../axios';
import _ from 'lodash';

const state = {
	templates: [],
	isLoading: false,
	error: null,
	currentTemplate: null
};

const getters = {
	getTemplates: (state) => state.templates,
	isTemplateLoading: (state) => state.isLoading,
	getTemplateError: (state) => state.error,
	getDefaultTemplates: (state) => state.defaultTemplates,
	getCurrentTemplate: (state) => state.currentTemplate
};

const actions = {
	[TEMPLATE_CREATE]: ({ commit }, template) => {
		return new Promise((resolve, reject) => {
			commit(TEMPLATE_REQUEST);

			axios
				.post('/api/v1/templates/', template)
				.then((resp) => {
					commit(TEMPLATE_SUCCESS, { template: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(TEMPLATE_ERROR, err);
					reject(err);
				});
		});
	},
	[TEMPLATE_GET_LIST]: ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(TEMPLATE_REQUEST);

			axios
				.get('/api/v1/templates/')
				.then((resp) => {
					commit(TEMPLATE_SUCCESS, { templates: resp.data });
					resolve(resp);
				})
				.catch((err) => {
					commit(TEMPLATE_ERROR, err);
					reject(err);
				});
		});
	}
};

const mutations = {
	[TEMPLATE_REQUEST]: (state) => {
		state.isLoading = true;
	},
	[TEMPLATE_SUCCESS]: (state, { templates, template }) => {
		state.isLoading = false;
		if (templates) {
			state.templates = templates;
		}

		if (template) {
			state.templates = state.templates.push(template);
			state.currentTemplate = template
		}
	},
	[TEMPLATE_SET_CURRENT]: (state, template) => {
		state.currentTemplate = template
	},
	[TEMPLATE_ERROR]: (state, error) => {
		state.isLoading = false;
		if (error) state.error = error;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
